import React from 'react';
import { TableRow, TableCell, Box } from '@mui/material';
import GoalStaticTableCell from './GoalStaticTableCell';

const GoalStaticsHeadquarterRow = ({ data, headers }) => {
  if (Array.isArray(data) && data.length === 0) {
    return <Box>데이터가 없습니다.</Box>;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return (
        <TableRow key={hIndex}>
          <TableCell align="center" sx={{ width: 200 }}>
            {hq.name}
          </TableCell>
          <GoalStaticTableCell data={hq} headerRows={headers} />
        </TableRow>
      );
    })
  );
};

export default GoalStaticsHeadquarterRow;
